"use client"
import React from "react"
import { AnalyticsProvider } from "@/components/analytics/AnalyticsProvider"
import { usePathname } from "next/navigation"
import { useMatches } from "react-router-dom"

import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import MarketingShell from '@/components/marketing/MarketingShell';
import { isBarePage, isMarketingPage } from '@/lib/publicPages';

export default function ProtectedLayout({ children }) {
  const pathname = usePathname();

  // (The old `hasMounted` first-tick gate guarded against Next.js SSR
  // hydration mismatch; this is a pure CSR build, so it only delayed first
  // paint by a render pass.)

  // Which pages are public, and which frame each gets, is lib/publicPages.js.
  const isVisible = !isBarePage(pathname);
  const isVisibleNameInNabar = pathname.startsWith(`/dashboard`);
  const isMarketingRoute = isMarketingPage(pathname);
  // An address no route matches (the catch-all in src/router.tsx) shows the
  // not-found page in the marketing shell, whatever the address starts with.
  const isNotFound = useMatches().some((match) => match.id === "not-found");

  // The active Vite tree supplies AppStateProvider, ContextGate, and Toaster
  // once in RootShell. Keeping this component layout-only lets signup and the
  // dashboard read the same profile state. app/layout.jsx is legacy Next code.
  return (
    <AnalyticsProvider>
      {isMarketingRoute || isNotFound ? (
        <MarketingShell notFound={isNotFound}>{children}</MarketingShell>
      ) : (
        <>
          {isVisible && <Navbar isVisibleNameInNabar={isVisibleNameInNabar} />}
          <div className="app-theme-stitch app-ui-scope">{children}</div>
          {isVisible && <Footer />}
        </>
      )}
    </AnalyticsProvider>
  );
}
